export const handleDownloadClick = (
    event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
    fileName: string,
    link: string
) => {
    if (!fileName) return;
    event.preventDefault();

    const a = document.createElement('a');
    a.href = link;
    a.download = fileName;

    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
};
